import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import NavBarTop from "../NavBarTop/NavBarTop";
import Footer from "../Footer/Footer";

const TermsPage = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />

        <meta charSet="utf-8" />
        <title>SerpMaze.com | Terms</title>
        <meta
          name="description"
          content="Read the SerpMaze.com Terms and conditions here. Always just get in touch with us if you have any questions. | SerpMaze.com | Free SERP Checker"
          data-react-helmet="true"
        />
      </Helmet>

      <div className="outer-wrapper-top-div">
        <Container fluid>
          <Row>
            <Col
              xs={12}
              lg={12}
              style={{
                display: "flex",
                justifyContent: "center",
                color: "black",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  maxWidth: "800px",
                }}
              >
                <h1
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  Terms and Conditions
                </h1>
                <p>
                  These terms of use govern your use of our site
                  www.serpmaze.com. Please read these terms in full before you
                  use this Website. If you do not accept these terms of use,
                  please do not use this Website. Your continued use of this
                  site confirms your acceptance of these terms.
                </p>

                <p>
                  This website is operated as SerpMaze by KVFD. Throughout the
                  site, the terms “we”, “us” and “our” refer to SerpMaze
                  operated by KVFD. KVFD offers this website, including all
                  information, tools and services available from this site to
                  you, the user, conditioned upon your acceptance of all terms,
                  conditions, policies and notices stated here.
                </p>

                <p>
                  By visiting our site you engage in our “Service” and agree to
                  be bound by the following terms and conditions (“Terms of
                  Service”, “Terms”), including those additional terms and
                  conditions and policies referenced herein and/or available by
                  hyperlink. These Terms of Service apply to all users of the
                  site, including without limitation users who are browsers,
                  vendors, customers, merchants, and/ or contributors of
                  content.
                </p>

                <p>
                  Please read these Terms of Service carefully before accessing
                  or using our website. By accessing or using any part of the
                  site, you agree to be bound by these Terms of Service. If you
                  do not agree to all the terms and conditions of this
                  agreement, then you may not access the website or use any
                  services. If these Terms of Service are considered an offer,
                  acceptance is expressly limited to these Terms of Service.
                </p>

                <p>
                  Any new features or content which are added to the current
                  site shall also be subject to the Terms of Service. You can
                  review the most current version of the Terms of Service at any
                  time on this page. We reserve the right to update, change or
                  replace any part of these Terms of Service by posting updates
                  and/or changes to our website. It is your responsibility to
                  check this page periodically for changes. Your continued use
                  of or access to the website following the posting of any
                  changes constitutes acceptance of those changes.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  WEB SITE ACCESS
                </h2>
                <p>
                  1.1 It is not necessary to register with us in order to use
                  parts of this Website. However, particular areas of this
                  Website will only be accessible only if you have registered.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  USE OF WEBSITE
                </h2>
                <p>
                  1.2 This Website may be used for your own private purposes and
                  in accordance with these terms of use.
                </p>

                <p>
                  1.3 You may print and download material from this Website
                  provided that you do not modify or reproduce any content
                  without our prior written consent.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  SITE UPTIME
                </h2>
                <p>
                  1.4 All reasonable measures are taken by us to ensure that
                  this Website is operational all day, every day. However,
                  occasionally technical issues may result in some downtime and
                  accordingly we will not be liable for any lost revenue or
                  business, inconvenience or costs incurred if this website is
                  unavailable at any time.
                </p>

                <p>
                  1.5 Where possible we always try to give advance warning of
                  maintenance issues that may result in Website down time but we
                  shall not be obliged to provide such notice.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  VISITOR PROVIDED MATERIAL
                </h2>
                <p>
                  1.6 Any material that a visitor to this Website sends or posts
                  to this Website shall be considered non-proprietary and non
                  confidential. We shall be entitled to copy, disclose,
                  distribute or use for such other purpose as we deem
                  appropriate all material provided to us, with the exception of
                  personal information, the use of which is covered under our
                  Privacy Policy.
                </p>

                <p>
                  1.7 When using this website you shall not post or send to or
                  from this Website any material:
                </p>

                <p>
                  for which you have not obtained all necessary copyright or
                  consents; that is discriminatory, obscene, pornographic,
                  defamatory, liable to incite racial hatred, in breach of
                  confidentiality or privacy, which may cause annoyance or
                  inconvenience to others, which encourages or constitutes
                  conduct that would be deemed a criminal offence, give rise to
                  a civil liability, or otherwise is contrary to the law in
                  Liechtenstein; which is harmful in nature including, and
                  without limitation, computer viruses, Trojan horses, corrupted
                  data, or other potentially harmful software or data. 1.8 We
                  will fully co-operate with any law enforcement authorities or
                  court order requiring us to disclose the identity or other
                  details of any person posting material to this website in
                  breach of Paragraph 1.7.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  LINKS TO AND FROM OTHER WEBSITES
                </h2>
                <p>
                  1.9 Throughout this Website you may find links to third party
                  websites. The provision of a link to such a website does not
                  mean that we endorse that website. If you visit any website
                  via a link on this Website you do so at your own risk.
                </p>

                <p>
                  1.10 Any party wishing to link to this website is entitled to
                  do so provided that the conditions below are observed:
                </p>

                <p>
                  you do not seek to imply that we are endorsing the services or
                  products of another party unless this has been agreed with us
                  in writing; you do not misrepresent your relationship with
                  this website; and the website from which you link to this
                  Website does not contain offensive or otherwise controversial
                  content or, content that infringes any intellectual property
                  rights or other rights of a third party. 1.11 By linking to
                  this Website in breach of clause 5.2 you shall indemnify us
                  for any loss or damage suffered to this Website as a result of
                  such linking.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  DISCLAIMER
                </h2>
                <p>
                  1.12 Whilst we do take all reasonable steps to make sure that
                  the information on this website is up to date and accurate at
                  all times we do not guarantee that all material is accurate
                  and ,or up to date.
                </p>

                <p>
                  1.13 All material contained on this Website is provided
                  without any or warranty of any kind. You use the material on
                  this Website at your own discretion.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  EXCLUSION OF LIABILITY
                </h2>
                <p>
                  1.14 We do not accept liability for any loss or damage that
                  you suffer as a result of using this Website.
                </p>

                <p>
                  1.15 Nothing in these Terms of Use shall exclude or limit
                  liability for death or personal injury caused by negligence
                  which cannot be excluded or under the law of the
                  Liechtenstein.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  TERMINATION OF SERVICE
                </h2>
                <p>
                  1.16 We reserve the right to terminate your service at any
                  time for any reason we see fit and may take steps to prevent
                  further access if required to safeguard the continued service
                  for other users.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  FAIR USAGE
                </h2>
                <p>
                  1.17 Access to this website and all parts of the service are
                  subject to a fair usage policy and if we deem that your access
                  contravenes this, for whatever reason, then we may take steps
                  to restrict or prevent further access in order to safeguard
                  the continued service for other users.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  DATA OWNERSHIP
                </h2>
                <p>
                  1.18 All data stored or generated by this website and service
                  is the property of the website and may be removed or modified
                  without notification.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  FREE USAGE
                </h2>
                <p>
                  1.19 Parts of this website and service may be offered for free
                  use however this is restricted only one account per
                  user/entity.
                </p>

                <p>
                  1.20 Any free usage quotas or functionality may be restricted
                  or changed without notice.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  PRIVACY
                </h2>
                <p>
                  1.21 We will never share any personal information without your
                  consent unless forced to by law.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  PRICING
                </h2>
                <p>
                  1.22 We reserve the right to change our fees or pricing at any
                  time, upon notice to you if such change may affect your
                  existing or future subscriptions.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  MARKETING
                </h2>
                <p>
                  1.23 When signing up on SerpMaze you accept that we can start
                  sending you marketing emails. You can unsubscribe to these
                  emails at any time you want.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  CHANGES TO TERMS OF SERVICE
                </h2>
                <p>
                  1.24 You can review the most current version of the Terms of
                  Service at any time at this page. We reserve the right, at our
                  sole discretion, to update, change or replace any part of
                  these Terms of Service by posting updates and changes to our
                  website. It is your responsibility to check our website
                  periodically for changes. Your continued use of or access to
                  our website or the Service following the posting of any
                  changes to these Terms of Service constitutes acceptance of
                  those changes.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  CONTACT INFORMATION
                </h2>
                <p>
                  1.25 Questions about the Terms of Service should be sent to us
                  at contact@serpmaze.com.
                </p>

                <h2
                  className="mt-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  GOVERNING LAW
                </h2>
                <p>
                  1.26 These Terms of Service and any separate agreements
                  whereby we provide you Services shall be governed by and
                  construed in accordance with the laws of Denmark.
                </p>

                <p style={{ display: "flex", justifyContent: "center" }}>
                  {" "}
                  LAST UPDATED ON AUGUST 13,2023
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default TermsPage;
